import { useEffect, useState } from "react";

const isDropzOpsUser = localStorage.getItem("isDropzOpsUser");

const featureFlags = {
	expertHelp: false,
	oneClickApply: false,
	dsp: true,
	featureToggle: isDropzOpsUser || false,
	posterGenerator: isDropzOpsUser || false,
	companyClaim: false,
};

export const supportedJobs = ["684b8f9d2dcc2c09c71b092d", "686366962dcc2c09c71b0936", "686366962dcc2c09c71b0937"];

export function useFeatureFlag(flagName) {
	const [isEnabled, setIsEnabled] = useState(false);

	useEffect(() => {
		setIsEnabled(!!featureFlags[flagName]);
	}, [flagName]);

	// In development, always enable features for testing
	return import.meta.env.DEV ? true : isEnabled;
}
